export default "__VITE_PUBLIC_ASSET__ecdd3685__"